import React, {Fragment} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {NavLink, withRouter} from 'react-router-dom';

import './index.scss';

import * as routes from "../../../../constants/routes";
import {createFiltersUrl, getMediaPath, urlEncodeString} from "../../../../app/functions";
import {setSearchFilters} from '../../../../redux/actions';
import * as Routes from "../../../../constants/routes";

const SubCategoriesGrid = (props) =>{

    //import data from redux
    const text = useSelector(store => store.config.Translations);

    const subCategories = useSelector(store => store.config.SubCategoryMenu);

    const handleOptionOnClick = (search_params, id) =>{
        props.history.push(routes.category + '/' + id + '/' + search_params.category);
    };


    const getItems = () =>{
        let res = [];

        for (let key in subCategories){
            const item = subCategories[key];
            res.push(
                <div key={key} className='sub-category' onClick={() => handleOptionOnClick(item.searchParams, item.id)}>
                    <div className='details'>
                        <span>{text['category_grid_item_span']}</span>
                        <span className='title'>{item.title}</span>
                        <span className='all-items'>{text['category_grid_all_items']}</span>
                    </div>
                    <img src={getMediaPath(item.imagePath)} alt={item.title}/>
                </div>
            )
        }

        return res;
    };

    return Object.keys(subCategories).length !== 0 ? (
        <section className='sub-categories-grid'>
            <h2>{text['category_grid_title']}</h2>
            <NavLink className="link" to={Routes.benefits}>{text['category_grid_sub_title']}</NavLink>
            <div className='category-container'>
                {getItems()}
            </div>
        </section>
    ) : null;
};

export default withRouter(SubCategoriesGrid);